import React from 'react'
import { NavLink } from 'react-router-dom';
import Product from './Product'

const style = {
  width: "100%"
};

const imgstyle = {
  width: "100%",
  height: "60vh"
}

const Home = () => {
  return (
    <div>
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>

        </ol>
        <div class="carousel-inner" style={style}>
          <div class="carousel-item active" >
          <img src="https://www.pngall.com/wp-content/uploads/5/iPhone-12-PNG-Pic.png" class="d-block " alt="/Online shoping image/hd/images (1).jpg" style={imgstyle} />
          </div>
          <div class="carousel-item">
            <img src="https://applemagazine.com/wp-content/uploads/2022/07/bHfOSj7.0.png.jpeg" class="d-block " alt="/Online shoping images/hd/images (2).jpg" style={imgstyle} />
          </div>
          <div class="carousel-item">
            <img src="https://galaxyventures18.com/wp-content/uploads/2021/09/SIDE.png" class="d-block " alt="/Online shoping images/images (4).jpg" style={imgstyle} />
          </div>
          <div class="carousel-item">
            <img src="https://gds-storage-prd.s3.amazonaws.com/unified-gallery/211212/3627/9cf667dc/thumbnails/iphone-13-2021-dec-12-03-59-22am-000-customizedview1042466602-png-3500-3500.jpg" class="d-block" alt="/Online shoping images/images (4).jpg" style={imgstyle} /></div>
        </div>
        <button class="carousel-control-prev" type="button" data-target="#carouselExampleIndicators" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-target="#carouselExampleIndicators" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </button>
      </div>
    <Product/>  
    </div>
  )
}

export default Home